import { gql } from "@apollo/client"

export const GET_ALL_MODEMS = gql`
  query getTerminalModems($selectedChannel: String!, $modemSlugs: [String!]) {
    products(channel: $selectedChannel, first: 100, filter: { slugs: $modemSlugs }) {
      edges {
        node {
          id
          name
          slug
          category {
            id
            name
          }
        }
      }
    }
  }
`
